/** @format */

import {
  POST_IMPORTERS_REQUEST,
  POST_IMPORTERS_SUCCESS,
  POST_IMPORTERS_FAILURE,
} from "./FetchImportersTypes";

const initialState = {
  loading: false,
  importers: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_IMPORTERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case POST_IMPORTERS_SUCCESS:
      return {
        loading: false,
        importers: action.payload,
        error: "",
      };
    case POST_IMPORTERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
